/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const adminModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор"),
"login": z.string().describe("Логин")
    })